export var FEATURE_FLAG_ENABLE_CHILDREN_ORGANIZATION_MANAGEMENT = ['ENABLE_CHILDREN_ORGANIZATION_MANAGEMENT', 'V5'];